// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__xydG6 g-grid-container","panels":"style_panels__RK3Fn","panel":"style_panel__eRlyO","panelInner":"style_panelInner__BxMY0"};